type BrandWordmarkProps = {
  compact?: boolean;
};

export function BrandWordmark({ compact = false }: BrandWordmarkProps) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <svg
        aria-hidden="true"
        viewBox="0 0 40 32"
        fill="none"
        className={`${compact ? "h-7 w-9" : "h-8 w-10"} shrink-0 text-secondary`}
      >
        <path d="M2 8C8 3 14 3 20 8s12 5 18 0" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 16c6-5 12-5 18 0s12 5 18 0" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 24c6-5 12-5 18 0s12 5 18 0" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span className="flex shrink-0 flex-col font-display font-bold leading-none text-primary-foreground">
        <span className={compact ? "text-xl" : "text-2xl"}>
          Go<span className="text-secondary">Pro</span>
        </span>
        <span className="mt-1 whitespace-nowrap text-[9px] font-semibold uppercase tracking-[0.18em] text-primary-foreground/75">
          Projects Limburg
        </span>
      </span>
    </span>
  );
}